import axios, { AxiosInstance } from 'axios';
import type { MerchantOnboardingRequestDto, MerchantOnboardingResponseDto, PublicCategoryDto } from '@kardume/types';
import { API_URL } from './env';

/**
 * Dedicated axios instance for the public (logged-out) routes.
 *
 * The shared `api` instance attaches the bearer token and clears the session on
 * a 401 - undesirable here, since the onboarding wizard is used by merchants
 * who do not have an account yet.
 */
const publicApi: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

/**
 * Public self-service merchant onboarding.
 *
 * Base: kardume_urbano_core. Both routes are listed under
 * `app.security.permit-all-paths` and require no authentication.
 */
export const onboardingApi = {
  /** Categories available when classifying the store (`GET /v1/categories`). */
  listCategories(): Promise<PublicCategoryDto[]> {
    return publicApi.get<PublicCategoryDto[]>('/v1/categories').then((r) => r.data);
  },

  /** Submit the application (`POST /v1/onboarding/merchant`) - creates a PENDING lead. */
  applyMerchant(payload: MerchantOnboardingRequestDto): Promise<MerchantOnboardingResponseDto> {
    return publicApi
      .post<MerchantOnboardingResponseDto>('/v1/onboarding/merchant', payload)
      .then((r) => r.data);
  },
};

export default onboardingApi;
